var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgItLeftImage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 172,
    height: 121,
    viewBox: "0 0 172 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.03031 62.6699C6.63031 62.6699 6.24031 62.5199 5.93031 62.2199L3.09031 59.3799C2.48031 58.7799 2.48031 57.7899 3.09031 57.1899C3.70031 56.5799 4.68031 56.5799 5.28031 57.1899L8.12031 60.0299C8.73031 60.6299 8.73031 61.6199 8.12031 62.2199C7.82031 62.5199 7.42031 62.6699 7.03031 62.6699Z",
    fill: "#748FFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7696 119.53C29.4196 119.53 29.0696 119.4 28.8096 119.13C28.2796 118.6 28.2796 117.74 28.8096 117.21L31.2996 114.72C31.8296 114.19 32.6896 114.19 33.2196 114.72C33.7496 115.25 33.7496 116.11 33.2196 116.64L30.7296 119.13C30.4696 119.4 30.1196 119.53 29.7696 119.53Z",
    stroke: "#748FFC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8303 117.58C68.6643 117.58 69.3403 116.904 69.3403 116.07C69.3403 115.236 68.6643 114.56 67.8303 114.56C66.9964 114.56 66.3203 115.236 66.3203 116.07C66.3203 116.904 66.9964 117.58 67.8303 117.58Z",
    stroke: "#748FFC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1299 11.7197L53.2999 23.8397",
    stroke: "#748FFC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9697 79.3701L35.1197 73.3301",
    stroke: "#748FFC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8896 114.83L29.6096 104.66",
    stroke: "#748FFC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.99023 45.8096L41.4802 51.8196",
    stroke: "#748FFC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.37988 91.9502C1.85988 99.1902 8.09988 104.66 15.3399 104.19",
    stroke: "#748FFC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.7003 1.01953C59.7803 1.01953 56.6104 4.18953 56.6104 8.10953",
    stroke: "#748FFC",
    strokeWidth: 1.0099,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2649 33.0545C26.3343 30.7139 28.5801 24.78 26.2811 19.8009C23.9822 14.8218 18.009 12.683 12.9396 15.0236C7.87026 17.3643 5.62443 23.2981 7.9234 28.2772C10.2224 33.2563 16.1956 35.3951 21.2649 33.0545Z",
    fill: "#3B5BDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3118 31.657C26.3811 29.3164 28.627 23.3826 26.328 18.4035C24.029 13.4244 18.0558 11.2855 12.9865 13.6261C7.91714 15.9668 5.6713 21.9006 7.97027 26.8797C10.2692 31.8588 16.2424 33.9977 21.3118 31.657Z",
    fill: "#91A7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6201 26.0902C18.0801 26.9802 21.6401 24.9202 22.5801 21.4902",
    stroke: "white",
    strokeWidth: 1.0099,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.749 21.6019C13.0649 21.4561 13.2046 21.0858 13.0611 20.7749C12.9175 20.4641 12.5451 20.3303 12.2292 20.4761C11.9133 20.622 11.7736 20.9923 11.9171 21.3031C12.0607 21.614 12.4331 21.7478 12.749 21.6019Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5127 17.3734C19.8286 17.2276 19.9683 16.8573 19.8247 16.5464C19.6812 16.2355 19.3088 16.1018 18.9929 16.2476C18.677 16.3935 18.5373 16.7637 18.6808 17.0746C18.8243 17.3855 19.1968 17.5193 19.5127 17.3734Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.97 99.9991H61.9697C59.1697 99.9991 56.8896 97.7291 56.8896 94.9191V31.9491C56.8896 29.1491 59.1597 26.8691 61.9697 26.8691H165.97C168.77 26.8691 171.05 29.1391 171.05 31.9491V94.9291C171.04 97.7291 168.77 99.9991 165.97 99.9991Z",
    fill: "#91A7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.05 44.46H63.2402V85.72H151.05V44.46Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.31 39.8399H65.49C63.56 39.8399 62 38.2799 62 36.3499V34.8699C62 32.9399 63.56 31.3799 65.49 31.3799H88.31C90.24 31.3799 91.8 32.9399 91.8 34.8699V36.3499C91.8 38.2799 90.24 39.8399 88.31 39.8399Z",
    fill: "#748FFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7701 93.9993H48.9701C47.3701 93.9993 46.0801 92.7093 46.0801 91.1093V45.7093C46.0801 44.1093 47.3701 42.8193 48.9701 42.8193H80.7701C82.3701 42.8193 83.6601 44.1093 83.6601 45.7093V91.1093C83.6601 92.7093 82.3701 93.9993 80.7701 93.9993Z",
    fill: "#5C7CFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.9994 38.2497C69.4574 38.2497 70.6394 37.0678 70.6394 35.6097C70.6394 34.1517 69.4574 32.9697 67.9994 32.9697C66.5413 32.9697 65.3594 34.1517 65.3594 35.6097C65.3594 37.0678 66.5413 38.2497 67.9994 38.2497Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.9896 38.2497C78.4476 38.2497 79.6296 37.0678 79.6296 35.6097C79.6296 34.1517 78.4476 32.9697 76.9896 32.9697C75.5316 32.9697 74.3496 34.1517 74.3496 35.6097C74.3496 37.0678 75.5316 38.2497 76.9896 38.2497Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.9799 38.2497C87.4379 38.2497 88.6199 37.0678 88.6199 35.6097C88.6199 34.1517 87.4379 32.9697 85.9799 32.9697C84.5218 32.9697 83.3398 34.1517 83.3398 35.6097C83.3398 37.0678 84.5218 38.2497 85.9799 38.2497Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.42 79.3695H97.3403C96.6203 79.3695 96.0303 78.7794 96.0303 78.0594V77.4995C96.0303 76.7795 96.6203 76.1895 97.3403 76.1895H107.42C108.14 76.1895 108.73 76.7795 108.73 77.4995V78.0594C108.73 78.7794 108.14 79.3695 107.42 79.3695Z",
    fill: "#BAC8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.64 79.3695H119.56C118.84 79.3695 118.25 78.7794 118.25 78.0594V77.4995C118.25 76.7795 118.84 76.1895 119.56 76.1895H129.64C130.36 76.1895 130.95 76.7795 130.95 77.4995V78.0594C130.94 78.7794 130.36 79.3695 129.64 79.3695Z",
    fill: "#BAC8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4902 48.6895H76.9902",
    stroke: "white",
    strokeWidth: 1.0579,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149 30.7196H104.25C101.37 30.7196 99.0303 28.3796 99.0303 25.4996V23.2796C99.0303 20.3996 101.37 18.0596 104.25 18.0596H149C151.88 18.0596 154.22 20.3996 154.22 23.2796V25.4996C154.22 28.3796 151.88 30.7196 149 30.7196Z",
    fill: "#748FFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.82 28.8691V35.6591L117.24 28.8691H110.82Z",
    fill: "#748FFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.5 22.7695H132",
    stroke: "white",
    strokeWidth: 1.0579,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.5 25.9492H145.76",
    stroke: "white",
    strokeWidth: 1.0579,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4902 61.9199H76.9902",
    stroke: "white",
    strokeWidth: 1.0579,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4902 68.2598H71.1702",
    stroke: "white",
    strokeWidth: 1.0579,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4902 71.4395H71.1702",
    stroke: "white",
    strokeWidth: 1.0579,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4902 74.6094H66.4102",
    stroke: "white",
    strokeWidth: 1.0579,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4902 86.25H66.4102",
    stroke: "white",
    strokeWidth: 1.0579,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4902 82.0195H66.4102",
    stroke: "white",
    strokeWidth: 1.0579,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4902 84.1299H72.7602",
    stroke: "white",
    strokeWidth: 1.0579,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4902 65.0898H56.3602",
    stroke: "white",
    strokeWidth: 1.0579,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1797 65.0898H69.0597",
    stroke: "white",
    strokeWidth: 1.0579,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4902 55.5693H68.5302",
    stroke: "white",
    strokeWidth: 1.0579,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4902 58.7393H63.2402",
    stroke: "white",
    strokeWidth: 1.0579,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4902 52.3896H59.0102",
    stroke: "white",
    strokeWidth: 1.0579,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1797 52.3896H79.6397",
    stroke: "white",
    strokeWidth: 1.0579,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2498 86.78C49.3423 86.78 52.6598 83.4624 52.6598 79.37C52.6598 75.2775 49.3423 71.96 45.2498 71.96C41.1574 71.96 37.8398 75.2775 37.8398 79.37C37.8398 83.4624 41.1574 86.78 45.2498 86.78Z",
    fill: "#DBE4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5101 77.3398L50.5401 79.4998L47.3701 81.5898",
    stroke: "#748FFC",
    strokeWidth: 1.0579,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43 81.5898L39.96 79.4398L43.14 77.3398",
    stroke: "#748FFC",
    strokeWidth: 1.0579,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5294 59.1494H88.6494V71.1694H89.5294V59.1494Z",
    fill: "#748FFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.9894 64.2891H90.1094V71.1591H90.9894V64.2891Z",
    fill: "#748FFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.4591 65.1592H91.5791V71.1692H92.4591V65.1592Z",
    fill: "#748FFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.9191 61.5596H93.0391V71.1696H93.9191V61.5596Z",
    fill: "#748FFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.3898 65.4893H94.5098V71.1593H95.3898V65.4893Z",
    fill: "#748FFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8497 61.1191H95.9697V71.1691H96.8497V61.1191Z",
    fill: "#748FFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.3097 59.4492H97.4297V71.1592H98.3097V59.4492Z",
    fill: "#748FFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.7794 62.5098H98.8994V71.1698H99.7794V62.5098Z",
    fill: "#748FFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.239 61.1191H100.359V71.1691H101.239V61.1191Z",
    fill: "#748FFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.699 60.4395H101.819V71.1694H102.699V60.4395Z",
    fill: "#748FFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.169 63.9297H103.289V71.1597H104.169V63.9297Z",
    fill: "#748FFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.629 61.2891H104.749V71.1691H105.629V61.2891Z",
    fill: "#748FFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.81 59.1494H117.93V71.1694H118.81V59.1494Z",
    fill: "#748FFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.879 69.1895H114.999V71.1595H115.879V69.1895Z",
    fill: "#748FFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.419 67.8398H113.539V71.1698H114.419V67.8398Z",
    fill: "#748FFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.1 61.5596H106.22V71.1696H107.1V61.5596Z",
    fill: "#748FFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.949 65.4893H112.069V71.1593H112.949V65.4893Z",
    fill: "#748FFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.339 61.1191H116.459V71.1691H117.339V61.1191Z",
    fill: "#748FFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.489 59.4492H110.609V71.1592H111.489V59.4492Z",
    fill: "#748FFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.02 62.5098H109.14V71.1698H110.02V62.5098Z",
    fill: "#748FFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.199 61.1191H122.319V71.1691H123.199V61.1191Z",
    fill: "#748FFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.739 60.4395H120.859V71.1694H121.739V60.4395Z",
    fill: "#748FFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.56 63.9297H107.68V71.1597H108.56V63.9297Z",
    fill: "#748FFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.27 61.2891H119.39V71.1691H120.27V61.2891Z",
    fill: "#748FFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.659 64.2891H123.779V71.1591H124.659V64.2891Z",
    fill: "#748FFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.129 69.1895H125.249V71.1595H126.129V69.1895Z",
    fill: "#748FFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.589 67.8398H126.709V71.1698H127.589V67.8398Z",
    fill: "#748FFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.06 61.5596H128.18V71.1696H129.06V61.5596Z",
    fill: "#748FFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.52 65.4893H129.64V71.1593H130.52V65.4893Z",
    fill: "#748FFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.98 61.1191H131.1V71.1691H131.98V61.1191Z",
    fill: "#748FFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.449 59.4492H132.569V71.1592H133.449V59.4492Z",
    fill: "#748FFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.909 62.5098H134.029V71.1698H134.909V62.5098Z",
    fill: "#748FFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.379 61.1191H135.499V71.1691H136.379V61.1191Z",
    fill: "#748FFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.839 60.4395H136.959V71.1694H137.839V60.4395Z",
    fill: "#748FFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.299 63.9297H138.419V71.1597H139.299V63.9297Z",
    fill: "#748FFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.77 61.2891H139.89V71.1691H140.77V61.2891Z",
    fill: "#748FFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.23 61.5596H141.35V71.1696H142.23V61.5596Z",
    fill: "#748FFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.159 62.5098H144.279V71.1698H145.159V62.5098Z",
    fill: "#748FFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.699 63.9297H142.819V71.1597H143.699V63.9297Z",
    fill: "#748FFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.2197 52.6895H111.6",
    stroke: "#748FFC",
    strokeWidth: 1.0579,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.489 54.4794L111.289 52.6894L109.489 50.8994H111.019L112.809 52.6894L111.019 54.4794H109.489Z",
    fill: "#748FFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.73 51.9593C145.608 51.9593 146.32 51.2474 146.32 50.3693C146.32 49.4912 145.608 48.7793 144.73 48.7793C143.852 48.7793 143.14 49.4912 143.14 50.3693C143.14 51.2474 143.852 51.9593 144.73 51.9593Z",
    fill: "#5C7CFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.239 51.9593C128.118 51.9593 128.829 51.2474 128.829 50.3693C128.829 49.4912 128.118 48.7793 127.239 48.7793C126.361 48.7793 125.649 49.4912 125.649 50.3693C125.649 51.2474 126.361 51.9593 127.239 51.9593Z",
    fill: "#5C7CFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.779 51.9593C119.658 51.9593 120.369 51.2474 120.369 50.3693C120.369 49.4912 119.658 48.7793 118.779 48.7793C117.901 48.7793 117.189 49.4912 117.189 50.3693C117.189 51.2474 117.901 51.9593 118.779 51.9593Z",
    fill: "#5C7CFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.699 51.9593C136.578 51.9593 137.289 51.2474 137.289 50.3693C137.289 49.4912 136.578 48.7793 135.699 48.7793C134.821 48.7793 134.109 49.4912 134.109 50.3693C134.109 51.2474 134.821 51.9593 135.699 51.9593Z",
    fill: "#5C7CFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2402 27H101.32",
    stroke: "#748FFC",
    strokeWidth: 1.0579,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9297 100H114.02",
    stroke: "#748FFC",
    strokeWidth: 1.0579,
    strokeMiterlimit: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItLeftImage);
export default __webpack_public_path__ + "static/media/itLeftImage.64be424764bdfbc9b74ff393eee8e3d6.svg";
export { ForwardRef as ReactComponent };